import { Card } from "@mui/material";
import { ActionMenuItem } from "../../../../components/action-menu/ActionMenuItem";
import UserCardHeader from "./UserCardHeader";
import { User } from "../../user-administration/user-list/UserList";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

export type UserCardProps = {
    user: User;
    variant?: "elevation" | "outlined";
    elevation?: number;
    onEdit?: (user: User) => void;
    onDelete?: (user: User) => void;
    onDisable?: (user: User, disable: boolean) => void;
    onDisableNotifications?: (user: User) => void;
    onViewUsageHistory?: (user: User) => void;
    onSendLoginEmail?: (user: User) => void;
};

export default function UserCard({
    user,
    variant,
    elevation,
    onEdit,
    onDelete,
    onDisable,
    onDisableNotifications,
    onViewUsageHistory,
    onSendLoginEmail,
    children
}: PropsWithChildren<UserCardProps>) {
    const { t } = useTranslation();
    const actionItems = new Array<ActionMenuItem>();

    if (onEdit) {
        actionItems.push({
            label: t("actions.edit"),
            onClick: () => {
                onEdit(user);
            }
        });
    }

    if (onDelete) {
        actionItems.push({
            label: t("actions.delete"),
            onClick: () => {
                onDelete(user);
            }
        });
    }

    if (onDisable) {
        actionItems.push({
            label: user.isDisabled
                ? t("actions.enable")
                : t("actions.disable"),
            onClick: () => {
                onDisable(user, !user.isDisabled);
            }
        });
    }

    if (onDisableNotifications) {
        actionItems.push({
            label: user.notificationDisableSettings
                ? t("actions.enableNotifications")
                : t("actions.disableNotifications"),
            onClick: () => {
                onDisableNotifications(user);
            }
        });
    }

    if (onViewUsageHistory) {
        actionItems.push({
            label: t("actions.viewUsageHistory"),
            onClick: () => {
                onViewUsageHistory(user);
            }
        });

    }

    if (onSendLoginEmail) {
        actionItems.push({
            label: t("actions.sendLoginEmail"),
            onClick: () => {
                onSendLoginEmail(user);
            }
        });

    }

    return (
        <Card variant={variant} elevation={elevation}>
            <UserCardHeader user={user} actionItems={actionItems} />
            {children}
        </Card >
    );
}


